import styled from 'styled-components';

export const Example = styled('div')`
  display: flex;
`;
